/*
  Application Login Page
*/

import React, { useEffect } from "react";
import { Link, useHistory } from "react-router-dom";

// Redux
import { useDispatch, useSelector } from "react-redux";

// Antd
import { Form, Button, Space } from "antd";

// Components
import AuthenticationBase from "..";
import {
  Email,
  Password,
} from "@Vytelle/admin/src/components/Common/FormElements";

// Constants
import APP_URL from "@Vytelle/admin/src/constants/ApplicationUrls";

// Config
import { APP_AUTH } from "@Vytelle/admin/src/config/environment";

// Helper
import { getErrorMessage } from "@Vytelle/admin/src/helpers/GeneralHelper";
import {
  errorNotification,
  successNotification,
} from "@Vytelle/admin/src/helpers/Notification";

// Actions
import {
  login,
  validateToken,
} from "@Vytelle/admin/src/store/actions/AuthAction";

// Storage Service
import StorageService from "@Vytelle/admin/src/services/StorageService";

// Localization
import LOCALIZATION from "@Vytelle/admin/src/services/LocalizationService";
import { useCookie } from "@Vytelle/admin/src/hooks/useCookie";

function Login() {
  const dispatch = useDispatch();
  const history = useHistory();

  // Refs
  const [form] = Form.useForm();
  let formRef = React.createRef();

  const { getToken, removeCookieByKey } = useCookie();

  // // Access the token from cookies
  const token = getToken() || null;

  // const searchParams = new URLSearchParams(location.search);
  // const token = searchParams.get("token");

  // Redux States
  const loading = useSelector((state) => state?.Auth?.loading);

  useEffect(() => {
    if (!!token) {
      validateTokenForLogin();
    } else {
      goToAdminLogin();
    }
  }, []);

  const validateTokenForLogin = () => {
    dispatch(validateToken(token)).then(
      () => {
        let domain = "";
        const hostName = window.location.hostname || "";
        if (hostName !== "localhost") {
          if (!!hostName?.length) {
            domain = hostName.substring(hostName?.indexOf("."));
            if (domain?.includes(":")) {
              domain = domain.split(":")[0];
            }
          }
        }
        removeCookieByKey(domain);
        history.push("/");
        // setCookieByKey("logout", false);
      },
      () => {
        goToAdminLogin();
        errorNotification(LOCALIZATION.SESSION_EXPIRED);
      }
    );
  };

  const goToAdminLogin = () => {
    if(!!StorageService.instance.getAccessToken()) {
      history.push(APP_URL.USER_LIST);
    }else {
      window.location.replace(APP_AUTH + "login");
    }
  };

  const onSubmit = (data) => {
    dispatch(login(data)).then(
      (e) => {
        successNotification(LOCALIZATION.SUCCESSFULLY_LOGIN_MESSAGE);
        const data = e?.data?.result;
        history.push({
          pathname: APP_URL.APP_LANDING_SCREEN,
          state: { data },
        });
      },
      (e) => {
        errorNotification(
          getErrorMessage(e, LOCALIZATION.UN_SUCCESSFULLY_LOGIN_MESSAGE)
        );
      }
    );
  };

  return !!token ? (
    <Space
      align="center"
      direction="vertical"
      style={{ width: "100%", justifyContent: "center" }}
    >
      <span>Please Wait...</span>
    </Space>
  ) : (
    !StorageService.instance.getAccessToken() && (
      <AuthenticationBase loading={loading} isLoginScreen={true}>
        <h2 className="sub-head">{LOCALIZATION.LOGIN}</h2>

        <Form form={form} ref={formRef} onFinish={onSubmit} layout="vertical">
          <div className="form-group">
            <Email
              className="form-control"
              name="email"
              required={true}
              placeholder={LOCALIZATION.EMAIL_ADDRESS}
            />
          </div>

          <div className="form-group">
            <Password
              className="form-control"
              name="password"
              required={true}
              minLength={1}
              placeholder={LOCALIZATION.PASSWORD}
            />
          </div>

          <Link to={APP_URL.FORGOT_PASSWORD}>
            {LOCALIZATION.FORGOT_PASSWORD}?
          </Link>

          <Form.Item>
            <Button
              block
              size="medium"
              type="primary"
              htmlType="submit"
              className="mt-4 auth-action"
            >
              {LOCALIZATION.LOGIN}
            </Button>
          </Form.Item>
        </Form>
      </AuthenticationBase>
    )
  );
}

export default Login;
